
// Declare the Extension Method

function orderBy<T extends object>(this: Array<T> | undefined, attr: string): Array<T> {
    if (!this || this.length === 0) return []; // handle undefined or empty array

    // filter out undefined or null elements
    const filtered = this.filter((x): x is T => x != null);

    const firstElement = filtered[0];
    if (!(attr in firstElement)) return filtered;

    return filtered.sort((a: any, b: any) => {
        if (a[attr] > b[attr]) return 1;
        if (b[attr] > a[attr]) return -1;
        return 0;
    });
}

// Extend Array globally
declare global {
    interface Array<T> {
        orderBy(attribute: string): Array<T>;
    }
}

Array.prototype.orderBy = orderBy;

export {};